export default {
  your_ip_address: 'Your Ip Address',
  when_clicked_copied_to_clipboard: 'When clicked copied to clipboard'
}
